import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, fmtErr } from "@/lib/api";
import { Brand } from "@/components/Brand";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Brand /></div>
        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm p-6 sm:p-8" data-testid="reset-password-card">
          <h1 className="text-2xl font-bold font-heading text-slate-900">Set a new password</h1>
          {error && <div data-testid="reset-error" className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-3">{error}</div>}
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-slate-300 px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="New password (min 6 characters)" />
            <button type="submit" data-testid="reset-submit-btn" disabled={loading || !token}
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl font-semibold text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-60 transition-colors">
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Update Password
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-slate-600"><Link to="/login" className="font-semibold text-blue-700">Back to login</Link></p>
        </div>
      </div>
    </div>
  );
}
